<template>
  <div
    class="border-gray flex flex-col gap-3 rounded-lg border bg-white shadow-md"
    :class="className"
  >
    <CollapsibleComponent>
      <template #title>
        <div
          class="flex items-center justify-between rounded-lg bg-white py-2 pl-3 pr-1 text-xs font-semibold text-dark-gray"
        >
          <p class="text-xl font-medium">
            {{ title }}
          </p>
          <LoadBadge
            v-if="badgeText"
            :text="badgeText"
            :color="badgeColor"
          />
        </div>
      </template>
      <template #content>
        <slot />
      </template>
    </CollapsibleComponent>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { CollapsibleComponent } from '@/components';
import LoadBadge from '@/components/loads/LoadBadge.vue';

defineProps({
  title: String,
  load: Object,
  badgeText: String,
  className: Object,
  badgeColor: {
    type: String,
    required: false,
    default: 'gray',
  },
});
</script>
